import { render, staticRenderFns } from "./CodeModal.vue?vue&type=template&id=836f13aa&scoped=true&"
import script from "./CodeModal.vue?vue&type=script&lang=js&"
export * from "./CodeModal.vue?vue&type=script&lang=js&"
import style0 from "./CodeModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CodeModal.vue?vue&type=style&index=1&id=836f13aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836f13aa",
  null
  
)

export default component.exports